// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"18":"product","392":"banner","443":"about","471":"show","601":"faction"}[chunkId] || chunkId) + "." + {"18":"f703066c","392":"dbc8a82f","440":"61a91419","443":"200ff867","471":"9f582faa","601":"3347467a"}[chunkId] + ".js";
};